import PropTypes from 'prop-types';

/* eslint-disable camelcase */

export const LINK_PROP_TYPES = PropTypes.shape({
    link_type: PropTypes.string.isRequired,
    target: PropTypes.string,
    url: PropTypes.string,
});

export const CTA_BUTTON_PROP_TYPES = PropTypes.shape({
    cta_external_link: LINK_PROP_TYPES,
    in_page_anchor: PropTypes.string,
    cta_text: PropTypes.string,
});

export const IMAGE_PROP_TYPES = PropTypes.shape({
    alt: PropTypes.string,
    copyright: PropTypes.string,
    dimensions: PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number,
    }),
    url: PropTypes.string,
    linkTo: LINK_PROP_TYPES,
});

export const RICHTEXT_PROP_TYPES = PropTypes.arrayOf(
    PropTypes.shape({
        spans: PropTypes.arrayOf(
            PropTypes.shape({
                end: PropTypes.number,
                start: PropTypes.number,
                type: PropTypes.string,
            })
        ),
        text: PropTypes.string,
        type: PropTypes.string,
    })
);

export const SLICE_PROP_TYPES = {
    slice_type: PropTypes.string.isRequired,
    primary: PropTypes.object.isRequired,
    items: PropTypes.array.isRequired,
};
